import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/AppSatisfactionModal/InitialPage.png'
import _imports_1 from '@/assets/img/AppSatisfactionModal/SatisfiedPage.png'
import _imports_2 from '@/assets/img/AppSatisfactionModal/NotSatisfiedPage.png'


const _withScopeId = n => (_pushScopeId("data-v-5b259825"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "modal-body-image"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "modal-body-image"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "modal-body-image"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalPage = _resolveComponent("ModalPage")!
  const _component_BModal = _resolveComponent("BModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_BModal, {
      id: _ctx.id,
      modelValue: _ctx.show,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.show) = $event)),
      "no-close-on-backdrop": "",
      "no-close-on-esc": "",
      "hide-header-close": "",
      "hide-header": "",
      "hide-footer": "",
      centered: "",
      "no-fade": "",
      "no-header": "",
      "body-class": "p-0"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          (!_ctx.isClickedNotSatisfied && !_ctx.isClickedSatisfied)
            ? (_openBlock(), _createBlock(_component_ModalPage, {
                key: 0,
                acceptText: "満足",
                declineText: "不満",
                acceptButtonVariant: "secondary",
                onAccept: _ctx.onClickSatisfied,
                onDecline: _ctx.onClickNotSatisfied
              }, {
                description: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }, 8, ["onAccept", "onDecline"]))
            : (_ctx.isClickedSatisfied)
              ? (_openBlock(), _createBlock(_component_ModalPage, {
                  key: 1,
                  acceptText: "評価する",
                  declineText: "あとで",
                  acceptButtonVariant: "secondary",
                  onAccept: _ctx.onClickCheering,
                  onDecline: _ctx.onClickSatisfiedAndAfterSoon
                }, {
                  description: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["onAccept", "onDecline"]))
              : (_openBlock(), _createBlock(_component_ModalPage, {
                  key: 2,
                  acceptText: "コメントする",
                  declineText: "あとで",
                  onAccept: _ctx.onClickToRequest,
                  onDecline: _ctx.onClickNotSatisfiedAndAfterSoon
                }, {
                  description: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["onAccept", "onDecline"]))
        ])
      ], undefined, true),
      _: 1
    }, 8, ["id", "modelValue"])
  ]))
}